import React from 'react';
import { FormGroup, Col } from 'seduo-ui';
import classNames from 'classnames';
const FormGroupButton = ({ className, children }) => (<FormGroup row>
        <Col className={classNames('mt-6', className)}>{children}</Col>
    </FormGroup>);
export default FormGroupButton;
